export enum ROLES {
  ADMIN = "admin",
  AGENT = "agent",
}
